import { render, staticRenderFns } from "./OrderItemTracking.vue?vue&type=template&id=8d480e46&scoped=true"
import script from "./OrderItemTracking.vue?vue&type=script&lang=js"
export * from "./OrderItemTracking.vue?vue&type=script&lang=js"
import style0 from "./OrderItemTracking.vue?vue&type=style&index=0&id=8d480e46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d480e46",
  null
  
)

export default component.exports